module.exports = __webpack_public_path__ + "static/img/pic_word_132＊132@2x.76c159d9.png";